import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-column-info',
  imports: [SharedModule],
  templateUrl: './column-info.component.html',
  styleUrl: './column-info.component.scss'
})
export class ColumnInfoComponent {

  
  @Output() closeDialog = new EventEmitter();
  @Input() allLeadFeilds: any = [];

  selectedFields: any = {
    "Lead Source": [
      "Channel Partner",
      "Conference",
      "Field Visit",
      "Google",
      "Instagram",
      "Lead Gen Tools",
      "Live Session",
      "Personal",
      "Referral",
      "LinkedIn",
      "Website",
      "WhatsApp",
      "Tina",
      "Other",
    ],
    "Lead Status": [
      "New",
      "Active",
      "Pipeline /Budgetary",
      "Contacted",
      "Qualified",
      "Converted",
      "Closed - Lost",
      "Closed - Won",
      "Follow-up",
      "Not Interested",
      "Duplicate",
      "Disqualified",
      "Marketing Qualified Lead (MQL)",
      "Sales Qualified Lead (SQL)",
    ],
    "Lead Type": [
      "Cold Lead",
      "Warm Lead",
      "Hot Lead",
    ],
  };
  dynamicData: Record<string, string[]> = {}; // Store the data
  isLoading = true; // Show a loading spinner while data is fetched


  constructor() { }

  ngOnInit(): void {
    // const newFields = this.getSelectFields();


    // this.selectedFields = { ...newFields, ...this.selectedFields };

    // console.log(this.selectedFields);
    // this.isLoading = false;
    // this.dynamicData = this.selectedFields;
  }

  ngOnChanges(changes:SimpleChanges) {
    if (changes['allLeadFeilds'] && changes['allLeadFeilds'].currentValue != changes['allLeadFeilds'].previousValue) {
      const newFields = this.getSelectFields();
      this.selectedFields = { ...newFields, ...this.selectedFields };
      this.isLoading = false;
      this.dynamicData = this.selectedFields;
    }
  }

  getSelectFields() {

    if (!this.allLeadFeilds) {
      return;
    }

    const selectFields = this.allLeadFeilds.filter(
      (field: any) => field.type === 'select'
    );

    const result = selectFields.reduce((acc: any, field: any) => {
      if (field.label && field.data) {
        acc[field.label] = field.data;
      }
      return acc;
    }, {});

    return result;
  }

  getKeys(obj: Record<string, string[]>): string[] {
    return Object.keys(obj);
  }


  handleCloseDialog() {
    this.closeDialog.emit();
  }


}
